import React from 'react';
import { Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@material-ui/core';
import { useStyles } from './style';
export const SubmitOption = ({
  onSubmit
}) => /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement("div", {
  style: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}, /*#__PURE__*/React.createElement(Button, {
  style: {
    border: '1px solid'
  },
  onClick: onSubmit && onSubmit
}, "Save Changes")));
export const VisitAttributeMenu = ({
  anchor,
  attributes,
  onSubmit,
  handleAttributeChange
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, anchor(event => setAnchorEl(event.currentTarget)), /*#__PURE__*/React.createElement(Menu, {
    id: "long-menu",
    MenuListProps: {
      'aria-labelledby': 'long-button'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: () => setAnchorEl(null)
  }, attributes.map((visitAttribute, index) => visitAttribute.selectable && visitAttribute.uiavailable && /*#__PURE__*/React.createElement(MenuItem, {
    style: {
      maxHeight: '4vh'
    },
    key: `${visitAttribute.id}`
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: visitAttribute.isSelected,
      name: visitAttribute.name,
      onClick: () => {
        handleAttributeChange(visitAttribute, !visitAttribute.isSelected);
      }
    }),
    label: visitAttribute.name,
    key: `visitAttribute-${visitAttribute.id}`,
    classes: {
      label: classes.radioLabel,
      root: classes.radioLabel
    },
    style: {
      width: '100%'
    }
  }))), onSubmit && /*#__PURE__*/React.createElement(SubmitOption, {
    onSubmit: async () => {
      const saved = await onSubmit();

      if (saved === false) {
        return;
      }

      setTimeout(() => {
        setAnchorEl(null);
      }, 1000);
    }
  })));
};